export default function CartSvg( ) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1441.9 895.3">
      <g fill="#ddd">
        <path d="m150 0q0 40 30 70t70 30q42 0 71-30t29-70q0-42-29-71t-71-29q-40 0-70 29t-30 71z m500 0q0 40 30 70t70 30q42 0 71-30t29-70q0-42-29-71t-71-29q-40 0-70 29t-30 71z m-322 236q-36-10-34-23t44-13l562 0l0-76q0-20-20-20l-654 0q-20 0-20 20l0 76l-10 46l-98 454l-98 0l0 80q0 20 20 20l156 0q20 0 20-20l0-86l704 0l0-274q0-22-18-26z" horizAdvX="900" />
      </g>
    </svg>
  )
}
